const PurchasedCard = {
    searchApi: () =>'store/purchase-cart/products',
    viewApi:()=>'store/purchase-cart/view',
    addProductApi:()=>'store/purchase-cart/add',
    removeProductApi:(id:string)=>`store/purchase-cart/remove-item/${id}`,
    checkoutApi:()=>'store/purchase-cart/checkout'
  }
  export default PurchasedCard